import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import {
  PublicClientApplication,
  EventType,
  type EventMessage,
  type AuthenticationResult,
} from "@azure/msal-browser";
import { msalConfig } from "./configs/msal-config";

import "./styles/globals.css";

export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App pca={msalInstance} />
  </React.StrictMode>
);